import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WesternUnion } from './western-union';

@Component({
  selector: 'app-western-union-modal-update',
  templateUrl: './western-union-modal-update.component.html'
})
export class WesternUnionModalUpdateComponent 
extends BaseModalUpdateComponent<WesternUnion> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<WesternUnion>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
